
import { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";


export default function Allhotspot({hotspot, position}) {
    // states
    const {user} = useContext(UserContext);


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>{hotspot?.lib}</td>
            <td>{hotspot?.nomsite}</td>
            <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={hotspot.photo !== null ? hotspot?.photo : "/assets/imgs/blank.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{hotspot?.nom} {hotspot?.prenom}</div>
                        <div className="widget-subheading">{hotspot?.email}</div>
                    </div>
                </div>
            </td>
            <td>
                <span 
                    className={`badge ${
                        hotspot.etat === 1 ? "badge-warning" : 
                        hotspot.etat === 2 ? "badge-success" : 
                        (hotspot.etat === 3 || hotspot.etat === 10) ? "badge-danger" : 
                        ""
                        } mt-2`
                    } 
                    style={{fontSize: 14}}>
                        {hotspot?.etatdef}
                </span>
            </td>
            <td>{hotspot?.datecrea.slice(0, 16).replace("T", " à ")}</td>
            <td className="text-center">
                {(user?.isFullAction || user?.isAdminAction || user?.isConsulterHotspot) && 
                    <Link to={`/hotspot/${hotspot?.code}`} data-toggle="tooltip" title={textes.fr.viewhotspotlabel} data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                        <i className="fa fa-eye"></i>
                    </Link>
                }
            </td>
        </tr>
    )
}